import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Button from '@material-ui/core/Button';

const styles = theme => ({
  card: {
    display: 'flex',
  },
  details: {
    minWidth: 275,
    flexDirection: 'column',
  },
  button: {
    margin: theme.spacing.unit,
    background: 'rgba(230, 70, 38, 0.95)',
  },
  content: {
    minWidth: 275,
    width: 200,
  },
  cover: {
    width: 180,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
});

const Event = (props) => {
  const { classes, theme} = props;
  return (
    <div>
    { props.event_list ? (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cover}
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="p" variant="p">
          {props.event_list.name}
          </Typography>
        </CardContent>
        <div className={classes.controls}>
          <Link to={{ pathname: '/eventdetails/'+props.event_list.name}} style={{textDecoration:'none'}}>
            <Button variant="contained" color="primary" className={classes.button}>
                Details
            </Button>
          </Link>
          <Button variant="contained" color="primary" className={classes.button}>
                Book online
          </Button>            
        </div>
      </div>
    </Card>
    ) : null}
    </div>
  );
}

Event.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Event);





// WEBPACK FOOTER //
// ./src/components/Users/UserEvent.js